// "Combínalo con": agrega las 2 variantes al carrito en una sola llamada
// real a /cart/add.js (no simulado), y abre el cajón del carrito para
// que el cliente vea de inmediato que ya quedó todo adentro.
(function () {
  var botones = document.querySelectorAll('[data-tz-combina-agregar]');
  if (!botones.length) return;

  function pintarCarrito(secciones) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && secciones && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: secciones });
      if (typeof drawer.open === 'function') drawer.open();
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tz-combina-con' });
    }
  }

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var idPrincipal = boton.getAttribute('data-variante-principal');
      var idCombo = boton.getAttribute('data-variante-combo');
      var estado = boton.parentElement.querySelector('[data-tz-combina-estado]');
      var textoOriginal = boton.textContent;

      boton.disabled = true;
      boton.textContent = 'Agregando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(idPrincipal), quantity: 1 },
            { id: Number(idCombo), quantity: 1 },
          ],
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('No se pudo agregar');
          return r.json();
        })
        .then(function (res) {
          boton.textContent = '¡Agregado! 🎉';
          pintarCarrito(res.sections);
          setTimeout(function () {
            boton.disabled = false;
            boton.textContent = textoOriginal;
          }, 2500);
        })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
          if (estado) {
            estado.hidden = false;
            estado.textContent = 'No se pudo agregar. Intenta de nuevo.';
          }
        });
    });
  });
})();
